module.exports = __webpack_public_path__ + "img/main_bg.968b21b2.jpg";